import { useCallback, useEffect, useState } from 'react';

import { useDebouncedValue } from '@shared/hooks';

export const useSearchOrdersByQuery = () => {
    // const { setState, clearQueryValue } = useNuqsQueryState(ORDERS_SEARCH_QUERY);

    const [searchDraft, setSearchDraft] = useState('');
    const [searchApplied, setSearchApplied] = useState('');

    const trimmedDraft = searchDraft.trim();
    const debouncedDraft = useDebouncedValue(trimmedDraft, 1000);

    useEffect(() => {
        setSearchApplied(debouncedDraft);
    }, [debouncedDraft]);
    // const debouncedVal = useDebouncedValue(searchDraft, 1000);

    // const onSubmitSearch = async () => {
    //     if (searchDraft.length === 0) {
    //         clearQueryValue();
    //     }
    //     await setState(searchDraft.trim());
    // };

    const onChangeSearchDraft = (val: string) => {
        setSearchDraft(val);
    };

    const commitSearchDraft = useCallback(() => {
        setSearchApplied(trimmedDraft);
    }, [trimmedDraft]);

    return {
        searchDraft,
        searchApplied,
        onChangeSearchDraft,
        commitSearchDraft,
        setSearchDraft,
        setSearchApplied,
    };
};

// import { useEffect, useMemo, useState } from 'react';
//
// import { useDebouncedValue, useNuqsQueryState } from '@shared/hooks';
// import { ORDERS_SEARCH_QUERY } from '@widgets/OrdersRecognition/model/сonsts';
//
// export const useSearchOrdersByQuery = () => {
//     const { state, setState, clearQueryValue } = useNuqsQueryState(ORDERS_SEARCH_QUERY);
//
//     const urlValue = useMemo(() => (state ?? '').trim(), [state]);
//
//     const [searchDraft, setSearchDraft] = useState(urlValue);
//
//     useEffect(() => {
//         setSearchDraft(urlValue);
//     }, [urlValue]);
//
//     const debouncedDraft = useDebouncedValue(searchDraft, 800);
//     const normalized = useMemo(() => debouncedDraft.trim(), [debouncedDraft]);
//
//     useEffect(() => {
//         if (normalized === urlValue) return;
//
//         if (normalized.length === 0) {
//             if (urlValue.length > 0) clearQueryValue();
//             return;
//         }
//
//         void setState(normalized);
//     }, [normalized, urlValue, setState, clearQueryValue]);
//
//     return { searchDraft, setSearchDraft };
// };
